import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { loadBookmarks, addBookmark, updateBookmark, deleteBookmark } from "./bookmarks-actions.js";
import { bookmarksService } from "../service/bookmarks-service.js";

/**
 * Effects der Merkliste — Action rein, Action raus.
 *
 * Bei add/update/delete werden die Request-Daten über die Response gemergt:
 * im Firebase-Modus sind beide identisch (das Backend bestätigt, was gesendet
 * wurde), im Mock-Modus gleicht der Merge die zustandslosen Fixtures aus —
 * so bleibt die Demo konsistent, ohne den Vertrag zu verbiegen.
 */

export const loadBookmarksEffect = actions$.pipe(
  ofType(loadBookmarks.action),
  switchMap(() =>
    bookmarksService.listBookmarks().pipe(
      map((bookmarks) => loadBookmarks.success(bookmarks)),
      catchError((err) => of(loadBookmarks.fail(err))),
    ),
  ),
);

export const addBookmarkEffect = actions$.pipe(
  ofType(addBookmark.action),
  switchMap((action) =>
    bookmarksService.addBookmark(action.payload).pipe(
      map((added) => addBookmark.success({ ...added, ...action.payload })),
      catchError((err) => of(addBookmark.fail(err))),
    ),
  ),
);

export const updateBookmarkEffect = actions$.pipe(
  ofType(updateBookmark.action),
  switchMap((action) =>
    bookmarksService.updateBookmark(action.payload.id, action.payload.patch).pipe(
      map((updated) =>
        updateBookmark.success({ ...updated, ...action.payload.patch, id: action.payload.id }),
      ),
      catchError((err) => of(updateBookmark.fail(err))),
    ),
  ),
);

export const deleteBookmarkEffect = actions$.pipe(
  ofType(deleteBookmark.action),
  switchMap((action) =>
    bookmarksService.deleteBookmark(action.payload).pipe(
      map(() => deleteBookmark.success({ id: action.payload })),
      catchError((err) => of(deleteBookmark.fail(err))),
    ),
  ),
);

export const bookmarksEffects = [
  loadBookmarksEffect,
  addBookmarkEffect,
  updateBookmarkEffect,
  deleteBookmarkEffect,
];
